import { Divider, Form, FormInstance } from 'antd'
import { t } from 'i18next'
import { memo } from 'react'
import {
  ModalContentContainer,
  ModalTextDescription,
  ModalTextLabel,
} from '../../../../../../components'
import { FlowCytometryReviewAnalysisConfigurationFormValues } from './FlowCytometryReviewAnalysisConfigurationModalStep'
import { NO_DATA_PLACEHOLDER } from '../../../../../../constants/constants'

interface FlowCytometryReviewAnalysisConfigurationModalReviewStepProps {
  form: FormInstance<FlowCytometryReviewAnalysisConfigurationFormValues>
}

const FlowCytometryReviewAnalysisConfigurationModalReviewStep = memo(
  ({
    form,
  }: FlowCytometryReviewAnalysisConfigurationModalReviewStepProps) => {
    const experimentId = Form.useWatch('experimentId', form) ?? ''
    const additionalExperimentIds =
      Form.useWatch('additionalExperimentIds', form) ?? ''
    const ssrExperimentId = Form.useWatch('ssrExperimentId', form) ?? ''

    const patientId = Form.useWatch('patientId', form)
    const visitCode = Form.useWatch('visitCode', form)
    const tubeName = Form.useWatch('tubeName', form)
    const cytometer = Form.useWatch('cytometer', form)
    const plate = Form.useWatch('plate', form)
    const exportTime = Form.useWatch('exportTime', form)  
    const drugSpike = Form.useWatch('drugSpike', form)

    return (
      <ModalContentContainer>
        <Divider orientation="left" plain>
          {t('reviewAnalysisConfigurationModal.steps.data.title')}
        </Divider>
        <ModalTextLabel>
          {t('reviewAnalysisConfigurationModal.fields.experimentId.label')}
        </ModalTextLabel>
        <ModalTextDescription>{experimentId}</ModalTextDescription>
        <ModalTextLabel>
          {t('reviewAnalysisConfigurationModal.fields.ssrExperimentId.label')}
        </ModalTextLabel>
        <ModalTextDescription>{ssrExperimentId}</ModalTextDescription>

        {additionalExperimentIds?.trim() && (
          <>
            <ModalTextLabel>
              {t(
                'reviewAnalysisConfigurationModal.fields.additionalExperimentIds.label'
              )}
            </ModalTextLabel>
            <ModalTextDescription>{additionalExperimentIds}</ModalTextDescription>
          </>
        )}

        <Divider orientation="left" plain>
          {t('reviewAnalysisConfigurationModal.steps.sample.title')}
        </Divider>
        <ModalTextLabel>
          {t('reviewAnalysisConfigurationModal.sample.review.visitCode')}
        </ModalTextLabel>
        <ModalTextDescription>
          {visitCode ?? NO_DATA_PLACEHOLDER}
        </ModalTextDescription>
        <ModalTextLabel>
          {t('reviewAnalysisConfigurationModal.sample.review.tubeName')}
        </ModalTextLabel>
        <ModalTextDescription>
          {tubeName ?? NO_DATA_PLACEHOLDER}
        </ModalTextDescription>

        <ModalTextLabel>
          {t('reviewAnalysisConfigurationModal.sample.review.drugSpike')}
        </ModalTextLabel>
        <ModalTextDescription>
          {drugSpike ?? NO_DATA_PLACEHOLDER}
        </ModalTextDescription>

        <Divider orientation="left" plain>
          {t('reviewAnalysisConfigurationModal.steps.mapping.title')}
        </Divider>
        <ModalTextLabel>
          {t('reviewAnalysisConfigurationModal.steps.mapping.fields.patientIdPrefix')}
        </ModalTextLabel>
        <ModalTextDescription>
          {patientId ?? NO_DATA_PLACEHOLDER}
        </ModalTextDescription>
        <ModalTextLabel>
          {t('reviewAnalysisConfigurationModal.steps.mapping.fields.visitCodePrefix')}
        </ModalTextLabel>
        <ModalTextDescription>
          {visitCode ?? NO_DATA_PLACEHOLDER}
        </ModalTextDescription>
        <ModalTextLabel>
          {t('reviewAnalysisConfigurationModal.steps.mapping.fields.tubeNamePrefix')}
        </ModalTextLabel>
        <ModalTextDescription>
          {tubeName ?? NO_DATA_PLACEHOLDER}
        </ModalTextDescription>
        <ModalTextLabel>
          {t('reviewAnalysisConfigurationModal.steps.mapping.fields.cytometerPrefix')}
        </ModalTextLabel>
        <ModalTextDescription>
          {cytometer ?? NO_DATA_PLACEHOLDER}
        </ModalTextDescription>
        <ModalTextLabel>
          {t('reviewAnalysisConfigurationModal.steps.mapping.fields.platePrefix')}
        </ModalTextLabel>
        <ModalTextDescription>
          {plate ?? NO_DATA_PLACEHOLDER}
        </ModalTextDescription>
        <ModalTextLabel>
          {t('reviewAnalysisConfigurationModal.steps.mapping.fields.exportTimePrefix')}
        </ModalTextLabel>
        <ModalTextDescription>
          {exportTime ?? NO_DATA_PLACEHOLDER}
        </ModalTextDescription>
      </ModalContentContainer>
    )
  }
)

export default FlowCytometryReviewAnalysisConfigurationModalReviewStep

